export class ArchivoEntidad {
    constructor(
        public src: string = '', // url del archivo en (base 64)
        public nombre: string = '' // nombre del archivo
    ) { }
}